import { NavLink, Outlet, Navigate } from 'react-router-dom';
import {
  LayoutDashboard, Users, ShoppingBag, Flag, Megaphone,
  BarChart2, ScrollText, Shield, ChevronRight,
} from 'lucide-react';
import { useAuthStore } from '@/store';

const NAV = [
  { to: '/admin',              label: 'Dashboard',      icon: LayoutDashboard, end: true },
  { to: '/admin/users',        label: 'Users',          icon: Users },
  { to: '/admin/listings',     label: 'Listings',       icon: ShoppingBag },
  { to: '/admin/reports',      label: 'Reports',        icon: Flag },
  { to: '/admin/announcements',label: 'Announcements',  icon: Megaphone },
  { to: '/admin/analytics',    label: 'Analytics',      icon: BarChart2 },
  { to: '/admin/audit-log',    label: 'Audit Log',      icon: ScrollText },
];

export default function AdminLayout() {
  const user = useAuthStore((s) => s.user);

  if (!user?.is_admin) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-zinc-950">
      {/* Sidebar */}
      <aside className="w-56 flex-shrink-0 bg-white dark:bg-zinc-900 border-r border-gray-200 dark:border-zinc-800 flex flex-col">
        <div className="flex items-center gap-2 px-5 py-4 border-b border-gray-200 dark:border-zinc-800">
          <Shield className="h-5 w-5 text-brand-600 dark:text-brand-400" />
          <span className="font-bold text-sm">Admin Panel</span>
        </div>
        <nav className="flex-1 py-3 space-y-0.5 px-2">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-brand-50 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300'
                    : 'text-gray-600 dark:text-zinc-400 hover:bg-gray-100 dark:hover:bg-zinc-800'
                }`
              }
            >
              <Icon className="h-4 w-4 flex-shrink-0" />
              {label}
              <ChevronRight className="h-3 w-3 ml-auto opacity-30" />
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-3 border-t border-gray-200 dark:border-zinc-800 text-xs text-gray-400 dark:text-zinc-600">
          Logged in as {user.username}
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
